export * from "./bem";
export * from "./coupled-child";
export * from "./coupled-parent";
export * from "./getPropByPath";
export * from "./props";
export function isUndef(value) {
  return value === null || value === void 0;
}
